import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpChartSeries } from './op-chart-series'
import { OpDescr } from '../core/op-descr'
import { OpFile } from '../core/op-file'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'
import { OpGaugeRange } from './op-gauge-range'


export class OpGaugeControl extends OpDashboardControl {
    //Properties
    public minValue: number
    public maxValue: number
    public ranges: OpGaugeRange[]
    public label: OpDescr
    public value: any
    //Properties end

    //NavigationProperties
    //NavigationProperties end

    constructor(opObj: any) {
        super(opObj)
        if (opObj) {
            this.width = opObj.Width
            this.module = opObj.Module

            this.minValue = opObj.MinValue
            this.maxValue = opObj.MaxValue
            this.value = opObj.Value

            if (opObj.Label)
                this.label = new OpDescr(opObj.Label)
            if (opObj.Ranges)
                this.ranges = opObj.Ranges.map(data => new OpGaugeRange(data))
        }
        if (!this.ranges)
            this.ranges = []
    }
}